<template>
  <div :class="getCssClass()" :type="input.type" :id="input.id" :style="input.style">
    <label>
            <span>
                {{ input.label }} <small v-if="input.required" class="required">*</small>&nbsp;
                <HelperBox v-if="input.helper" :text="input.helper"></HelperBox>
            </span>
      <template v-if="input.type == 'site-name-readonly'">
        <input type="hidden" :value="getNestedValue(formValue, input.value)"/>
        <div style="padding:10px;border: 1px solid rgba(92,91,100,0.15)">{{ getSiteName(formValue.siteReference.id) }}</div> 
      </template>
      <template v-if="input.type == 'text' || input.type == 'email' || input.type == 'password'">
        <input :type="input.type"
               :placeholder="input.placeholder"
               :value="getNestedValue(formValue, input.value)"
               v-on:keyup="onValueChange($event, input.value, input.callback)"
               v-on:blur="autoSave()"
               :disabled="isDisabled()"/>
      </template>
      <template v-if="input.type == 'number'">
        <input type="text"
               :placeholder="input.placeholder"
               :value="getNestedValue(formValue, input.value)"
               v-on:keyup="onNumberKeyUp($event, input)"
               v-on:keydown="onNumberKeyDown($event, input)"
               v-on:blur="autoSave()"
               :disabled="isDisabled()"/>
      </template>
      <template v-if="input.type == 'textarea'">
                <textarea :type="input.type"
                          :placeholder="input.placeholder"
                          v-on:keyup="onValueChange($event, input.value, input.callback)"
                          v-on:blur="autoSave()"
                          :disabled="isDisabled()">{{ getNestedValue(formValue, input.value) }}</textarea>
      </template>
      <template v-if="input.type == 'calendar'">
        <template v-if="isDisabled()">
          <input type="text" :value="formatIsoDateToShortDate(getNestedValue(formValue, input.value))" disabled="disabled" >
        </template>
        <template v-else>
          <date-picker type="date" v-model="datePickerModel" :default-value="getNestedValue(formValue, input.value)" format="DD-MMM-YYYY"
                       placeholder="DD-MMM-YYYY"
                       v-on:change="setDateValue($event, input.value, input.callback)"></date-picker>
        </template>
      </template>
      <template v-if="input.type === 'treatmentgroup-for-actuals'">
        <template v-if="getDispensingUnits(formValue).length === 0">
          <div style="padding-bottom:20px;">
            You need to have defined dispensingunits before you can select treatment group for actuals.
          </div>
        </template>
        <template v-else-if="getTreatmentGroupsActuals().length === 0">
          <div style="padding-bottom:20px;">
            You need to have defined treatmentgroups before you can choose any actuals.
          </div>
        </template>
        <template v-else>
       
                <div class="inner grid-50w">
                  <div v-for="tg in getTreatmentGroupsActuals()" class="input">
                    <label>
                      Actual for: {{tg.name}}
                    <input type="hidden" :value="tg.id"/>
                    <input type="text"
                         pattern="[0-9]+([\.][0-9]{1,2})?"
                         placeholder="Actual enrolment"
                         :value="tg.enrolled"
                         :disabled="isDisabled()"/>
                    </label>
                  </div>
              </div>
        </template>
        
      </template> 
      <template v-if="input.type === 'planned-batch-stock-adjustments'">
          <template v-if="getPlannedBatchs().length === 0">
            <div style="padding-bottom:20px;">
              You need to have planned batches before making stock adjustments.
            </div>
          </template>
        <template v-else-if="getPlannedBatchesForStockAdjustment(formValue).length === 0">
          <div style="padding-bottom:20px;">
            There are no planned batches that fullfill criteria. 
          </div>
        </template>
          <template v-else-if="getSupplyChains().length === 0">
            <div style="padding-bottom:20px;">
            You need to have defined a supply chaing before making stock adjustments.
            </div>
          </template>
          <template v-else-if="getDispensingUnits(formValue).length === 0">
            <div style="padding-bottom:20px;">
            You need to have defined dispensingunits before making stock adjustments.
            </div>
          </template>        
          <template v-else>
            <select v-on:change="onValueChange($event, input.value, input.callback)"
                    v-on:blur="autoSave()"
                    :disabled="isDisabled()">
              <option>Please select a production/planned-batch</option>
              <option v-for="plannedBatch in this.getPlannedBatchesForStockAdjustment(formValue)"
                      :value="plannedBatch.batchGuid"
                      :selected="getNestedValue(formValue, input.value) === plannedBatch.batchGuid ? 'selected' : ''">
                {{ plannedBatch.name }}
              </option>
            </select>
          </template>
      </template>
      <template v-else-if="input.type == 'select'">
        <select v-on:change="onValueChange($event, input.value, input.callback)"
                v-on:blur="autoSave()"
                :disabled="isDisabled()">
          <option value="">Select item</option>
          <template v-if="input.preValues == 'supplyStrategies'">
            <option v-for="pre in this.$store.getters.supplyStrategies"
                    :value="pre.value"
                    :selected="getNestedValue(formValue, input.value) == pre.value ? 'selected' : ''">
              {{ pre.name }}
            </option>
          </template>
          <template v-if="input.preValues == 'primaryPackages'">
              <option v-for="pre in this.getPrimaryPackages(formValue)"
                      :value="pre.id"
                      :selected="getNestedValue(formValue, input.value) == pre.id ? 'selected' :  ''">
                {{ pre.name }}
              </option>
          </template>
          <template v-if="input.preValues == 'secondaryPackages'">
            <option v-for="pre in this.getSecondaryPackages(formValue)"
                    :value="pre.id"
                    :selected="getNestedValue(formValue, input.value) == pre.id ? 'selected' :  ''">
              {{ pre.name }}
            </option>
          </template>          
          <template v-if="input.preValues == 'dispensingUnits'">
            <option v-for="pre in this.getDispensingUnits(formValue)"
                    :value="pre.id"
                    :selected="getNestedValue(formValue, input.value) == pre.id ? 'selected' :  ''">
              {{ pre.name }}
            </option>
          </template>          
          <template v-if="input.preValues == 'studyDosageForms'">
            <option v-for="pre in this.$store.getters.studyDosageForms"
                    :value="pre"
                    :selected="getNestedValue(formValue, input.value) == pre ? 'selected' : ''">
              {{ pre }}
            </option>
          </template>
          <template v-else-if="input.preValues == 'studyPackaging'">
            <option v-for="pre in this.$store.getters.studyPackaging"
                    :value="pre"
                    :selected="getNestedValue(formValue, input.value) == pre ? 'selected' : ''">
              {{ pre }}
            </option>
          </template>
          <template v-else-if="input.preValues == 'studyUnits'">
            <option v-for="pre in this.$store.getters.studyUnits"
                    :value="pre"
                    :selected="getNestedValue(formValue, input.value) == pre ? 'selected' : ''">
              {{ pre }}
            </option>
          </template>
          <template v-else-if="input.preValues == 'currency'">
            <option v-for="pre in this.$store.getters.currencyList"
                    :value="pre.code"
                    :selected="getNestedValue(formValue, input.value) == pre.code ? 'selected' : ''">
              {{ pre.code }} - {{ pre.symbol }}
            </option>
          </template>
          <template v-else-if="input.preValues == 'countries'">
            <option v-for="pre in this.$store.getters.countryList"
                    :value="pre.code"
                    :selected="getNestedValue(formValue, input.value) == pre.code ? 'selected' : ''">
              {{ pre.name }}
            </option>
          </template>
          <template v-else-if="Array.isArray(input.preValues)">
            <option v-for="pre in input.preValues"
                    :value="pre.value"
                    :selected="getNestedValue(formValue, input.value) == pre.value ? 'selected' : ''">
              {{ pre.name }}
            </option>
          </template>
          <template v-else-if="typeof input.preValues == 'object'">
            <template v-if="input.preValues.field == 'supplyChainDepots'">
              <!-- Special select for SP Depots -->
              <option v-for="pre in this.getSelectSupplyChainDepots(input.preValues)"
                      :value="pre.supplyChainId"
                      :selected="getNestedValue(formValue, input.value) == pre.supplyChainId ? 'selected' : ''">
                {{ pre[input.preValues.name] }}
              </option>
            </template>
            <template v-else>
              <option v-for="pre in getGlobalValues(input.preValues.field, input.filter, input.value)"
                      :value="pre[input.preValues.value]"
                      :selected="getNestedValue(formValue, input.value) == pre[input.preValues.value] ? 'selected' : ''">
                {{ pre[input.preValues.name] }}
              </option>
            </template>
          </template>
        </select>
      </template>
      <template v-else-if="input.type == 'datalist'">
        <input type="text"
               :list="getDatalistName(input.value)"
               :value="getNestedValue(formValue, input.value)"
               :placeholder="input.placeholder"
               v-on:keyup="onValueChange($event, input.value, input.callback)"
               v-on:blur="autoSave()"
               :disabled="isDisabled()"/>
        <datalist :id="getDatalistName(input.value)">
          <template v-if="input.preValues == 'studyPackaging'">
            <option v-for="pre in this.$store.getters.studyPackaging"
                    :value="pre"
                    :selected="getNestedValue(formValue, input.value) == pre ? 'selected' : ''">
              {{ pre }}
            </option>
          </template>
        </datalist>
      </template>
      <template v-else-if="input.type == 'radiolist'">
        <section>
          <template v-for="pre in input.preValues">
            <label class="radio">
              <input type="radio"
                     :name="input.value + formValue.id"
                     :checked="getNestedValue(formValue, input.value) == pre.value"
                     :value="pre.value"
                     v-on:change="onValueChange($event, input.value, input.callback)"
                     v-on:blur="autoSave()"
                     :disabled="isDisabled()"/>
              <small>{{ pre.name == undefined ? pre : pre.name }}</small>
            </label>
          </template>
        </section>
      </template>
      <template v-else-if="input.type == 'checkboxlist'">
        <section>
          <template v-for="pre in input.preValues">
            <label class="radio">
              <input type="checkbox"
                     :checked="getNestedValue(formValue, input.value + '.' + pre.value)"
                     :value="getNestedValue(formValue, input.value + '.' + pre.value)"
                     v-on:change="onValueChange($event, input.value + '.' + pre.value, input.callback)"
                     v-on:blur="autoSave()"
                     :disabled="isDisabled()"/>
              <small>{{ pre.label }}</small>
            </label>
          </template>
        </section>
      </template>
      <template v-else-if="input.type == 'checkbox' || input.type == 'radio'">
        <section>
          <label class="radio">
            <input :type="input.type"
                   :checked="getNestedValue(formValue, input.value)"
                   :value="getNestedValue(formValue, input.value)"
                   v-on:change="onValueChange($event, input.value, input.callback)"
                   v-on:blur="autoSave()"
                   :disabled="isDisabled()"/>
            <small>{{ input.label }}</small>
          </label>
          <div v-if="input.description != ''" style="line-height:1.5;margin-left:17px;">{{ input.description }}</div>
        </section>
      </template>
      <template v-else-if="input.type == 'void'">
        <section class="void">&nbsp;</section>
      </template>
      <template v-else-if="input.type == 'button'">
        <button v-on:click="onButtonClick($event, input.callback)" type="button">{{ input.buttonText }}</button>
      </template>
      <template v-else-if="input.type == 'buttonlist'">
        <section>
          <button v-for="pre in input.preValues"
                  v-on:click="onButtonListClick(pre.globalValue, pre.callback)"
                  type="button">
            {{ pre.label }}
          </button>
        </section>
      </template>
      <template v-else-if="input.type == 'fileupload'">
        <label class="button" :for="this.toCustomFormName(input.buttonText)">
          <input :id="this.toCustomFormName(input.buttonText)" :name="this.toCustomFormName(input.buttonText)"
                 type="file" v-on:change="onFileUploadChange($event, input)" accept=".xlsx,.xls"/>
          {{ input.buttonText }}
        </label>
      </template>
      <template v-else-if="input.type == 'typeahead-countries'">
        <treeselect :multiple="input.multiple"
                    :options="this.getCountryOptions(formValue)"
                    :placeholder="input.placeholder"
                    :disable-branch-nodes="false"
                    :clearable="true"
                    :disableFuzzyMatching="true"
                    :append-to-body="true"
                    :instanceId="input.value"
                    :value="getNestedValueNullIfEmpty(formValue, input.value)"
                    value-consists-of="LEAF_PRIORITY"
                    @input="onTypeAheadChange"
                    @close="onTypeAheadCallback(input.callback, input.preValues.field)"
        />
      </template>      
      <template v-else-if="input.type == 'typeahead'">
        <treeselect :multiple="input.multiple"
                    :options="getTypeAheadData(input.preValues, input.appendAll, input.filter, input.value)"
                    @input="onTypeAheadChange"
                    @close="onTypeAheadCallback(input.callback, input.preValues.field)"
                    :value="getNestedValue(formValue, input.value)"
                    :instanceId="input.value"
                    :disable-branch-nodes="false"
                    :clearable="false"
                    :disableFuzzyMatching="true"
                    value-consists-of="LEAF_PRIORITY"
                    :append-to-body="true"
                    :placeholder="input.placeholder"/>
      </template>
      <template v-else-if="input.type == 'guid'">
        <input type="hidden"
               :value="getSetGuid(formValue, input.value)"/>
      </template>
      <template v-else-if="input.type == 'hidden'">
        <input type="hidden"
               :value="setFormNestedValue(input.preValue, input.value)"/>
      </template>
      <template v-else-if="input.type == 'label'">
        <section>{{ getNestedValue(formValue, input.value) }} &nbsp;</section>
      </template>

      <template v-if="input.inline">
        <small>{{ getInlineText(input.inline) }}</small>
      </template>
      <template v-else-if="input.inlineSelect">
        <small>
          <select v-on:change="onValueChange($event, input.value + 'Select', input.callback)"
                  v-on:blur="autoSave()"
                  :disabled="isDisabled()">
            <option v-for="option in input.inlineSelect"
                    :selected="getNestedValue(formValue, input.value + 'Select') == option.value ? 'selected' : ''"
                    :value="option.value">
              {{ option.name }}
            </option>
          </select>
        </small>
      </template>
    </label>
  </div>
</template>

<script>
import API from "../../../Api"
import Treeselect from "@riophae/vue-treeselect"
import DatePicker from "vue2-datepicker"
import 'vue2-datepicker/index.css';
import HelperBox from "../HelperBox.vue"

export default {
  name: "InputField",
  components: {
    Treeselect,
    DatePicker,
    HelperBox
  },
  props: {
    input: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: false
    }
  },
  data: function()
  {
    return  {datePickerModel : ""};
  },
  mounted: function() {
    if (!this.isDisabled() && this.input.type === 'calendar')
    {
      //this.$nextTick();
      //this.datePickerModel = "";
      this.setDateValue(this.getNestedValue(this.formValue, this.input.value),this.input.value);
    } 
  },
  methods: {
    isNull: function (value) {
      return value === undefined || value === null;
    },
    autoSetDispensingUnitInDr(formValue)
    {
      if (this.NullOrUndefined(formValue.secondaryPackagingId) || formValue.secondaryPackagingId === "")
        return;

      if (this.NullOrUndefined(formValue.dunId) || formValue.dunId === "")
        return;

      let dispensingUnits = this.getGlobalValues("dispensingUnits");

      if (this.NullOrUndefined(dispensingUnits)) {
        return;
      }

      dispensingUnits = dispensingUnits.filter(x=>x.id === formValue.dunId);
      
      if (dispensingUnits.length === 0)
        return;
      
      let dunsForDosageRegimen = dispensingUnits.filter(x => x.secondaryPackages.filter(y => y.secondaryPackages === formValue.secondaryPackagingId).length > 0);
      
      if (dunsForDosageRegimen.length === 1)
      {
        formValue.dunId = dunsForDosageRegimen[0].id;
      }
    },
    autoSetSecondaryPackageInDr(formValue)
    {
      /*if there is only one secondary package per primary package, this will auto-set*/ 
      
      if (this.isNull(formValue.primaryPackagingId) || formValue.primaryPackagingId === "")
          return;
      
      let secondaryPackages = this.getGlobalValues("secondaryPackages");
      
      if (this.isNull(secondaryPackages) || secondaryPackages.length === 0)
        return;
      
      let secondaryPackagesForDf = secondaryPackages.filter(x => x.primaryPackageId === formValue.primaryPackagingId);

      if (secondaryPackagesForDf.length === 1)
      {
          formValue.secondaryPackagingId = secondaryPackagesForDf[0].id;
      }
      
    },
    getSecondaryPackages(formValue) {
      
      
        
      let secondaryPackages = this.getGlobalValues("secondaryPackages");
      let primaryPackages = this.getGlobalValues("primaryPackages");
      
      //debugger;

      if (!this.isNull(formValue) && !this.isNull(formValue.dosage))
      {
                   
          let secondaryPackagesForDf = [];
        
          if (!this.isNull(formValue.primaryPackagingId) && formValue.primaryPackagingId !== "")
          {
              secondaryPackagesForDf = secondaryPackages.filter(x=>x.primaryPackageId === formValue.primaryPackagingId);
              
              if (secondaryPackagesForDf.length === 1)
              {
                  formValue.secondaryPackagingId = secondaryPackagesForDf[0].id;
                  
              }

              return secondaryPackagesForDf;
          }

          primaryPackages = this.getPrimaryPackages(formValue);

          
          for (let i=0; i < secondaryPackages.length; i++)
          {
                
                let secondaryPackage = secondaryPackages[i];
                
                for (let j=0; j < primaryPackages.length; j++)
                {
                    let primaryPackage = primaryPackages[j];
                    
                    if (secondaryPackage.primaryPackageId === primaryPackage.id)
                    {
                        secondaryPackagesForDf.push(secondaryPackage);
                    }
                }
          }
  
          if (secondaryPackagesForDf.length === 1)
          {
             formValue.secondaryPackagingId = secondaryPackagesForDf[0].id;

              this.autoSetDispensingUnitInDr(formValue);
          }

        return secondaryPackagesForDf;
          
                   
      }
      
      return secondaryPackages;
    },
    getPrimaryPackages(formValue) {

      let primaryPackages = this.getGlobalValues("primaryPackages");
  
      //debugger;
      if (!this.isNull(formValue) && !this.isNull(formValue.dosage))
      {

          let primaryPackagesForDf = [];
          let dosageFormId = formValue.dosage.dosageFormReference.id;
                   
          
          for (let i=0; i < primaryPackages.length; i++)
          {
              //this is fubar, but legacy bug added name for id.
              var primaryPackageDfId = primaryPackages[i].value.dosageFormId;
              
              if  (dosageFormId === primaryPackageDfId)
              {
                primaryPackagesForDf.push(primaryPackages[i]);
              }
          }
          
          if (primaryPackagesForDf.length === 1)
          {
              //we preset if primary packages are one....
              //debugger;
              formValue.primaryPackagingId = primaryPackagesForDf[0].id;

              this.autoSetSecondaryPackageInDr(formValue);
          }
          
          return primaryPackagesForDf;

      }
    
      //debugger;

      return primaryPackages;
    },
    getTreatmentGroupsActuals()
    {
      let treatmentGroups = this.getGlobalValues('treatmentGroups');
      let tgActuals = [];
      if (this.NullOrUndefined(treatmentGroups) || treatmentGroups.length === 0)
          return tgActuals;

      for (var i = 0; i < treatmentGroups.length; i++)
      {
        tgActuals.push( 
            {
              name: treatmentGroups[i].name,
              id: treatmentGroups[i].id,
              enrolled: 0
            } 
        ) ;       
      }

      
      return tgActuals;
    },
    getSiteName : function(siteId)
    {
      const sites =  this.getGlobalValues('sites');
      const site = sites.find(x => x.id === siteId);

      if (this.NullOrUndefined(site))
        return "";

      return site.name;
    },
    getPlannedBatchs()
    {
        let plannedBatches = this.getGlobalValues('production.plannedBatchs');

      if (this.NullOrUndefined(plannedBatches))
        return new [];
      
      
      return plannedBatches;
    },
    getSupplyChains()
    {
      let supplyChain = this.getGlobalValues("supplyChain");

      if (this.NullOrUndefined(supplyChain)) {
        return [];
      }
      
      return supplyChain;
    },
    getDispensingUnits(formValue)
    {
      let dispensingUnits = this.getGlobalValues("dispensingUnits");

      if (this.NullOrUndefined(dispensingUnits)) {
        return [];
      }

      //dosage regimen form value
      if (!this.isNull(formValue) && !this.isNull(formValue.dosage)) {
        
          let secondaryPackages = this.getSecondaryPackages(formValue);
          let dunsForDosageRegimen = [];

          if (!this.isNull(formValue.secondaryPackagingId) && formValue.secondaryPackagingId !== "")
          {
            dunsForDosageRegimen = dispensingUnits.filter(x => x.secondaryPackages.filter(y => y.secondaryPackages === formValue.secondaryPackagingId).length > 0);
  
            if (dunsForDosageRegimen.length === 1)
            {
              formValue.dunId = dunsForDosageRegimen[0].id;
            }
            return dunsForDosageRegimen;
          }
          
          
          for (let i=0; i < dispensingUnits.length; i++)
          {
             let dun = dispensingUnits[i];
             let addedDun = false;
             for (let j=0; j < dun.secondaryPackages.length; j++)
             {                
                 if (addedDun)
                    break;
               
                 //also fubar that id is stored here???
                 let dunSecondaryReferenceId = dun.secondaryPackages[j].secondaryPackages;
                 
                 for (let k=0; k < secondaryPackages.length; k++)
                 {
                    let secondary = secondaryPackages[k];
                   
                    if (secondary.id === dunSecondaryReferenceId)
                    {
                        dunsForDosageRegimen.push(dun);
                        addedDun = true;
                        break;
                    }
                 }  
             }
             
             
          }
          
          if (dunsForDosageRegimen.length === 1)
          {
              formValue.dunId = dunsForDosageRegimen[0].id;
          }
          
          return dunsForDosageRegimen;
      }
      
      return dispensingUnits;
    },
    getPlannedBatchesForStockAdjustment(formValue)
    {       
      
      
       let plannedBatches = this.getGlobalValues("production.plannedBatchs");
       let dispensingUnits = this.getGlobalValues("dispensingUnits");
       let depots = this.getGlobalValues("depots");
       
       let selectList = [];       

       for (var i = 0; i < plannedBatches.length; i++)
       {
         let batch = plannedBatches[i];
         let dun = dispensingUnits.find(dun => dun.id === batch.dispensingUnitId);
         let depot = depots.find(dep => dep.id === batch.depotId);

         if (this.NullOrUndefined(dun) || this.NullOrUndefined(depot))
         {
              continue;
         }
         let expiry = new Date(batch.expiry)
         let calculatedExpiry = expiry.setDate(expiry.getDate() - batch.doNotShipDuration*1);
         
         let item = {
           batchGuid : batch.batchGuid,
           name: batch.name + " (dun: " +  dun.name + ", depot: " + depot.name + ", available: " + this.formatIsoDateToShortDate(batch.availableDate) + ", expiry: " + this.formatIsoDateToShortDate(calculatedExpiry) + ")"
         };

         selectList.push(item);
       }
      
       return selectList;       
    },
    getCountryOptions(formValue) {
      //this is sloooow a.f. but how do we get it better?
      let allData = this.getGlobalValues();
      let options = []
      let countries = this.$store.getters.countryList;
      //debugger;
      allData.sites.forEach(x => {
        if (this.NullOrUndefined(options.find(y=>y.id === x.address.country)))
        {
          var countryName = countries.find(y=>y.code === x.address.country).name;
          var label = x.address.country + " (" + countryName + ")";
          options.push({id:x.address.country, label:label});
        }
      });
    
      options.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
      return options;
    },
    studyInterval() {
      let interval = this.$store.state.editor.version.data.studyInterval;
      if (!interval) {
        this.$store.state.editor.version.data.studyInterval = 5;
        return 5;
      }

      return interval;
    },
    getCssClass() {
      let cssClass = "input";

      if (this.input.extraClass)
        cssClass += " " + this.input.extraClass;

      if (this.input.inline || this.input.inlineSelect)
        cssClass += " inline";

      return cssClass;
    },
    isDisabled() {
      // First check if has Disabled prop
      if (this.input.disabled) return true;
      if (this.$route.name.indexOf("studyEditor") < 0 && this.$route.name.indexOf("studyAggregator") < 0) {
        return false;
      }

      let versionExist = this.$store.state.editor.version !== null;
      
      if (!versionExist)
        return false;

      let processStatus = this.$store.state.editor.version.processStatus;
      return processStatus === 2 || processStatus === 3;
    },
    onValueChange(e, key, callback) {
      if (e.target.type && e.target.type == "checkbox")
        this.setFormNestedValue(e.target.checked, key);
      else
        this.setFormNestedValue(e.target.value, key);

      if (this.input.type === "textarea") {
        const textarea = e.currentTarget;
        const cursorPosition = textarea.selectionStart;
        this.$nextTick(() => {
          if (textarea && textarea.selectionStart === 0) {
            textarea.selectionStart = cursorPosition;
            textarea.selectionEnd = cursorPosition;
          }
        });
      }

      // Callback
      if (callback)
        callback(this.formValue, this.getGlobalValues())
    },
    setFormNestedValue(value, key) {
      this.setNestedValue(this.formValue, value, key);
    },
    getSetGuid(object, field) {
      let val = this.getNestedValue(object, field);
      let guid = val ? val : this.$uuid.v4();

      this.setFormNestedValue(guid, field);

      return guid;
    },
    getGlobalValues(field, filter, value) {
      let version = this.$store.state.editor.version;
      let values = field ? this.getNestedValue(version.data, field) : version.data;

      if (filter) {
        let filterList = [];
        let currentValue = this.getNestedValue(this.formValue, value); // Remove current values

        let hasValue = currentValue !== 'undefined' && currentValue != null
        
        filterList = filter(this.formValue).filter(function (el) {
          return !hasValue || !currentValue.includes(el);
        });

        // Clean final list
        values = values.filter(function (el) {
          return !filterList.includes(el.id);
        });
      }

      return values;
    },
    setDateValue(date, key, callback) {
     // debugger;
      if (date !== "" && date !== "Invalid date")
      {
        let m = this.$moment(date);
        this.setFormNestedValue(m.format("YYYY-MM-DD"), key);
        this.datePickerModel = m.toDate();
      }
      else
      {
        this.setFormNestedValue("", key);
        this.datePickerModel = "";
      }
      
      if (callback)
        callback(this.formValue, this.getGlobalValues())

      this.autoSave();
    },
    setClearDateValue(key, callback) {
      this.setFormNestedValue("", key);

      if (callback)
        callback(this.formValue, this.getGlobalValues())
    },
    calendarDisableDays(date, hasInterval) {
      if (!hasInterval)
        return false;

      let studyInterval = this.studyInterval().state.editor.version.data;
      let a = this.$moment(this.$store.start, "YYYY-MM-DD");
      let b = this.$moment(date);
      let intervals = Math.floor(b.diff(a, "days") / studyInterval);

      return !b.isSame(a.add(intervals * studyInterval, "days"));
    },
    onButtonClick(e, f) {
      f(e)
    },
    onButtonListClick(global, f) {
      f(this.formValue, this.getGlobalValues(global))
    },
    onFileUploadChange(e, data) {
      let files = e.target.files || e.dataTransfer.files;

      if (files.length == 0) {
        alert("Please select .xlsx file");
        return false;
      }

      API.upload(data.fileUploadPath, files[0]).then((res) => {
        data.callback(this.formValue, res, this.getGlobalValues());
      }).catch((res) => {
        console.log(res);
        if (res.message) {
          console.log(res.message);
        }
        alert("Could not load file");
      });

      // Clear file
      e.target.value = "";
    },
    autoSave() {
      this.$nextTick(() => {
        if (this.$route.name.indexOf("study") != -1)
          this.$store.dispatch("saveCurrentForecastVersion");

        // Hack: when settings new SectionArrys like Dosage Forms, select dropdowns does not update in view
        // this hack force a new render
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      })
    },
    getDatalistName(value) {
      let id = this.replaceAll(value.toLowerCase(), ".", "");
      return "datalist_" + id;
    },
    getTypeAheadData(preValue, appendAll, filter, value) {
      // Format value to match a typeahead options list
      let list = [];
      let dataList = [];

      if (preValue.field === "countries") {
        dataList = this.$store.getters.countryList;
      } else {
        dataList = this.getGlobalValues(preValue.field);
      }

      let filterList = [];
      if (filter) {
        let currentValue = this.getNestedValue(this.formValue, value); // Remove current values
        let exists = currentValue !== 'undefined' && currentValue != null;

        filterList = filter(this.formValue).filter(function (el) {
          return !exists || !currentValue.includes(el);
        });
      }

      for (let global of dataList) {
        if (filterList.find(x => x === global[preValue.value]))
          continue;

        let item = {
          id: global[preValue.value],
          label: global[preValue.name]
        };

        if (preValue.groupBy) {
          item.group = this.getNestedValue(global, preValue.groupBy);

          let sub = list.find(e => e.group === item.group);
          if (sub) {
            if (!sub.children)
              sub.children = [];

            sub.children.push(item);
          } else {
            let group = {
              id: item.group,
              label: item.group,
              group: item.group,
              children: []
            };
            group.children.push(item);
            list.push(group);
          }
        } else {
          list.push(item);
        }
      }

      if (appendAll) {
        return [{
          id: "all",
          label: "All",
          children: list
        }];
      }

      return list;
    },
    onTypeAheadChange(values, instance) {
      this.setFormNestedValue(values, instance);
    },
    onTypeAheadCallback(func, readFrom) {
      if (func)
        func(this.formValue, this.getGlobalValues());
    },
    onNumberKeyUp(e, input) {
     
      if (!this.isKeyNumber(e, input?.allowNegative))
        return;
      
      e.target.value =  e.target.value.replace(/[^\d.-]/g, '');
      
      if (input.minValue) {
        if (parseInt(e.target.value) < input.minValue) {
          return;
        }
      }

      this.onValueChange(e, input.value, input.callback);
    },
    onNumberKeyDown(e, input) {
      if (!this.isKeyNumber(e, input?.allowNegative))
        e.preventDefault()
    },
    getInlineText(text) {
      if (text === "{currency}")
        return this.$store.state.editor.version.data.studyCurrency;
      else if (text === "{format}")
        return this.$store.state.editor.version.data.studyFormat;

      return text;
    },
    getSelectSupplyChainDepots(preValues) {
      if (preValues.field === "supplyChainDepots") {
        
        
        
        let supplyChain = this.getGlobalValues("supplyChain");
        let depots = this.getGlobalValues("depots");
        let dispensingUnits = this.getGlobalValues("dispensingUnits");
        let finalList = [];
        for (const scItem of supplyChain) {
          var dunNames = [];
          scItem.dispensingUnits.forEach(dunReference => {
                var dun = dispensingUnits.find(x => x.id === dunReference);

                if (this.NullOrUndefined(dun)) {
                  return;
                }

                dunNames.push(dun.name);
              }
          );
          for (const chain of scItem.supplyChains) {
            if (!chain.depotReference || chain.depotReference === "")
              continue;
           
            var depot = depots.find(x=> x.id === chain.depotReference.id);

            var selectName = depot.name;

            if (dunNames.length > 0) {
              selectName += " (" + dunNames.join(", ") + ")";
            }

            finalList.push({
              depotId: chain.depotReference.id,
              supplyChainId: chain.supplyChainId,
              name: selectName
            })
          }
        }
        return finalList;
      }

      return [];
    }
  }
}
</script>